
import "./panel.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";


import { useState, useEffect, useTransition } from "react";

/* banco de dados */
import { db, auth } from "../../services/firebaseConnection";
import { collection, getDocs, getDoc, doc, where, query, limit, orderBy, onSnapshot, writeBatch } from "firebase/firestore";

/* navegação */
import { useNavigate } from "react-router-dom";

/* funções auxiliares */
import { statusAgentsPanel, formatTimestamp, dateDiffDias, expiryDate, db_basic, agentsmanagement } from "../../services/functions/functions.ts";

/* gráfico */
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, LabelList } from "recharts";

/* agenda */
import AgendaPanel from "./agenda";

/* imagens */
import panel_agent from "../../assets/panel_agent.png";
import panel_graphics from "../../assets/panel_graphics.png";
import panel_payment from "../../assets/panel_payment.png";
import panel_config from "../../assets/panel_config.png";
import panel_schedule from "../../assets/panel_schedule.png";
import panel_management from "../../assets/panel_management.png";

/* rotas do cloud run */
import { ENDPOINTS } from "../../routes/endpoints.js";



/*
status dos agentes e ações:
  0	- cliente foi cadastrado - criar agente
  1	- agente foi criado mas não foi configurado - configurar agente
  2	- agente configurado mas pendente de ativação - ver detalhes
  3	- agente ativado - período de testes (7 dias)
  4	- agente ativado - cliente assinante
  5 - agente bloqueado - excedeu o consumo de créditos
  6	- agente desativado (pedido do cliente) - criar agente
  7	- agente desativado - falta de pagamento - criar agente
  8	- agente desativado - uso interno - criar agente
*/


export default function Panel() {

    const [basic, setBasic] = useState(null);
    const [dadosBilling, setDadosBilling] = useState([]);
    const [difhrs, setDifhrs] = useState(0);
    const [dtConf, setDataConf] = useState(null);
    const [dtAtiv, setDataAtiv] = useState(null);

    const [chart, setChart] = useState([]);
    const [agenda, setAgenda] = useState([]);
    const [idGptMaker, setIdGptMaker] = useState("");

    const [client, setClient] = useState([]);

    const navigate = useNavigate();

    const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const [loaded1, setLoaded1] = useState(false);
    const [loaded2, setLoaded2] = useState(false);
    const [loaded3, setLoaded3] = useState(false);
    const [loaded4, setLoaded4] = useState(false);
    const [loaded5, setLoaded5] = useState(false);
    const [loaded6, setLoaded6] = useState(false);
    const [loaded7, setLoaded7] = useState(false);
    const [loaded8, setLoaded8] = useState(false);

    const [credits, setCredits] = useState(0);
    const [agBlock, setAgBlock] = useState(0);

    const [agManagent, setAgManagent] = useState();


    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {

        const loadBasic = async () => {

            const uid = auth.currentUser.uid;
            const bbd = await db_basic(uid);
            setBasic(bbd);
            setLoaded3(true);
        };

        loadBasic();
        setLoaded8(false);

    }, []);


    useEffect(() => {

        if(!basic?.agent) return;

        const aid = basic.agent.id;
        const ast = basic.agent.status;
        
        if(!(ast >= 3 && ast <= 5)) return;

        const logsRef = collection(db, "ls_calendar");
        const q = query(logsRef, where("id_agent", "==", aid), orderBy("date", "desc"));

        const unsubscribe = onSnapshot(q, (snapshot) => {

            try {

                const docs = snapshot.docs;
                if (!docs || docs.length === 0) {
                    setAgenda([]);
                    return;
                }

                //transformar logs DESC → ASC
                const brutoDesc = docs.map(d => d.data());
                const bruto = [...brutoDesc].reverse();

                const processado = [];
                const usado = new Set();

                for (let i = 0; i < bruto.length; i++) {
                    if (usado.has(i)) continue;

                    const atual = bruto[i];
                    const timestampAtual = atual.date?.toDate ? atual.date.toDate().getTime() : 0;

                    if (atual.action === "CANCEL") {
                        for (let j = i + 1; j < bruto.length; j++) {
                            if (usado.has(j)) continue;

                            const prox = bruto[j];
                            const timestampProx = prox.date?.toDate ? prox.date.toDate().getTime() : 0;

                            const mesmoEmail = prox.email === atual.email;
                            const intervalo = Math.abs(timestampAtual - timestampProx);

                            if (prox.action === "ADD" && mesmoEmail && intervalo <= 30 * 60 * 1000) {

                                usado.add(i);
                                usado.add(j);
                                processado.push({dia: prox.dia.split('/').join('.'), hora: prox.hora, scheduledAt: prox.date?.toDate ? prox.date.toDate() : prox.date, nome: prox.nome || "", telefone: prox.telefone || "", action: "REAGENDADO", atendimento: prox.atendimento});
                                break;

                            }
                        }
                    }

                    if (!usado.has(i)) {
                        processado.push({dia: (atual.dia || "").split('/').join('.'), hora: atual.hora, scheduledAt: atual.date?.toDate ? atual.date.toDate() : atual.date, nome: atual.nome || "", telefone: atual.telefone || "", action: atual.action === "ADD" ? "AGENDADO" : "CANCELADO", atendimento: atual.atendimento});
                    }
                }

                //pegar últimos 4 registros (mais recentes)
                const final = processado.slice(-4);
                setAgenda(final);

            } catch(erro) {
                console.error("onSnapshot processing error:", erro);
            }
        });

        return () => unsubscribe();

    }, [basic]);



    useEffect(() => {

        if(!basic?.agent) return;

        const sts = basic.agent.status;

        const run = async () => {

            // 1️. agente atual
            (async () => {
                await wait(500);
                await load_agente();
                setLoaded1(true);
            })();

            // 3. gráfico de atendimentos
            if(sts >= 3 && sts <= 5) {
                (async () => {
                    await wait(1000);
                    await create_chart();
                    setLoaded2(true);
                })();
            }

            // 4. planos e pagamentos
            if(sts >= 4 && sts <= 5) {
                (async () => {
                    await wait(500);
                    await load_payments();
                    setLoaded4(true);
                })();
            }

            // 2. agenda
            if(sts >= 3 && sts <= 5) {
                (async () => {
                    await wait(1000);
                    await getNextSchedules();
                    setLoaded5(true);
                })();
            }

            // 6. gestão de agentes            
            (async () => {
                await wait(3000);
                const agmanagent = await agentsmanagement(basic.client.idDoc);
                setAgManagent(agmanagent);
                setLoaded7(true);
            })();

        };

        run();

    }, [basic]);



    // snapshot para bloquear o agente por limite de consumo de créditos
    useEffect(() => {

        if(!basic?.agent?.id) return;

        const agentRef = doc(db, "db_agent", basic.agent.id);

        const unsubscribe = onSnapshot(agentRef, (snap) => {

            if(!snap.exists()) return;

            const data = snap.data();

            const motivo = data.status_motivo;
            const status = data.status;

            // só considera bloqueio se for assinante ativo
            if(status === 5) {

                const partes = motivo.split(" ");
                const valor_consumo = partes.length >= 3 ? partes[2] : null;

                setAgBlock(valor_consumo);
                console.log("consumo: " + valor_consumo);
                
            } else {
                setAgBlock(0);
                console.log("consumo: 0");
            }

        });

        return () => unsubscribe();

    }, [basic?.agent?.id]);




    async function load_agente() {

        let sts = basic.agent.status;
        let pla = basic.agent.plano;
        let aid = basic.agent.id;
        
        try {

            if(sts > 1) {

                let rmo = "";
                switch(pla.substring(0, 3)) {
                    case "CMD": 
                        rmo = "db_medical";
                        break;
                    case "EST":
                        rmo = "db_aesthetic";  
                        break;
                }
                
                const agentRef = doc(db, rmo, aid);
                const agentSnap = await getDoc(agentRef);
                
                const agent = agentSnap.data();
                setDataConf(agent.data_criacao);
                
                if(sts === 3) {
                    setDifhrs(dateDiffDias(new Date(agent.data_criacao.toDate()), new Date()).horas);
                }

                if(sts === 3 || sts === 4) {
                    setDataAtiv(agent.data_criacao);
                }
                
                if(sts === 5) {

                    //verifica se o agente está bloqueado por consumo de créditos
                    const motivo = basic.agent.status_motivo;

                    if(motivo?.startsWith("Bloqueado Credito")) {
                        const partes = motivo.split(" ");
                        const valor = partes.length >= 3 ? partes[2] : null;

                        setAgBlock(valor);
                    }

                }
                
                if(sts > 5) {
                    setDataAtiv(agent.data_encerramento);
                }
                
            }                    
                
        }
        catch(erro) {
            alert("busca agente " + erro);
        }        

    }


    async function load_payments() {

        let aid = basic.agent.id;
        let cod = basic.agent.plano;

        try {

            // busca o billing do agente
            const billingRef = doc(db, "db_billing", aid);
            const billingSnap = await getDoc(billingRef);

            if(!billingSnap.exists()) {
                alert("Billing não encontrado.");
                return;
            }

            const billing = billingSnap.data();

            let tipoUltimaParcela = null;

            // verifica a regularidade de pagamento
            const hoje = new Date();
            let atrasado = false;

            if(Array.isArray(billing.parcelas)) {

                atrasado = billing.parcelas.some(parcela => {

                    const vencimento = parcela.vencimento?.toDate ? parcela.vencimento.toDate() : new Date(parcela.vencimento);

                    return parcela.status === "PENDING" && vencimento < hoje;

                });

                const ultimaParcela = billing.parcelas[billing.parcelas.length - 1];
                tipoUltimaParcela = ultimaParcela?.tipo ?? null;
        
            }

            // verifica o plano
            const planref = doc(db, "db_plan", cod);
            const plansnap = await getDoc(planref);

            if(!plansnap.exists()) {
                alert("Plano não encontrado.");
                return;
            }

            const plan = plansnap.data();

            const dad = {assinatura: formatTimestamp(billing.data_criacao), pagamento: tipoUltimaParcela, vencimento: billing.dia_vencimento, plano: plan.ramo, id_plano: plansnap.id, valor: plan.valor.toFixed(2), situacao: atrasado};

            setDadosBilling(dad);

            // consulta o consumo de créditos do agente
            const anoAtual = hoje.getFullYear();
            const mesAtual = hoje.getMonth() + 1;
            const diaAtual = hoje.getDate();

            const dataInicio = basic.agent.data_inicio_ativacao.toDate();

            const anoInicio = dataInicio.getFullYear();
            const mesInicio = dataInicio.getMonth() + 1;
            const diaInicio = dataInicio.getDate();

            let totalCreditos = 0;

            let tel = basic.agent.telefone;
            tel = "55" + tel.replace(/\D/g, "");

            const telephoneref = doc(db, "db_telephone", tel);
            const telephonesnap = await getDoc(telephoneref);

            if(telephonesnap.empty) {
                alert("Telefone não encontrado.");
                return;
            }

            const telefone = telephonesnap.data();
            const idg = telefone.id_gptmaker;

            const resGptMaker = await fetch(ENDPOINTS.gptmaker.agentCredits,
            {
                method: "POST",
                headers: {"Content-Type": "application/json"},

                body: JSON.stringify({agent_id: idg, year: anoAtual.toString(), month: mesAtual.toString()})
            }
            );

            const resultGptMaker = await resGptMaker.json();

            if(resultGptMaker.error) {
                return;
            }

            const resumo = resultGptMaker.data;

            if(anoAtual === anoInicio && mesAtual === mesInicio) {

                totalCreditos = resumo.filter(item => item.day >= diaInicio && item.day <= diaAtual).reduce((acc, item) => acc + item.credits, 0);

            } else {

                totalCreditos = resumo.filter(item => item.day <= diaAtual).reduce((acc, item) => acc + item.credits, 0);
            }

            setCredits(totalCreditos);

        }
        catch (erro) {
            alert("busca billings " + erro);
        }
    }



    function execute_agent(adicional) {

        if(!adicional) {

            let sts = basic.agent.status;
            
            if(sts === 1) {
                switch(basic.agent.plano.substring(0, 3)) {

                    case "CMD":
                        navigate("/medical");
                        break;
                    case "EST":
                        navigate("/aesthetic");
                        break;
                }

            } else if(sts === 3) {
                navigate("/billing");
            } else {
                navigate("/agent");
            }
        
        } else {

            // para criar um novo agente
            navigate("/agent", {state: {adicional: true}});

        }

    }

    
    async function create_chart() {
     
        try {
            
            let aid = basic.agent.id;
            let ast = basic.agent.status;

            const tel = "55" + basic.agent.telefone.replace(/\D/g, "");
            const dta = basic.agent.data_inicio_ativacao.toDate();
            const start_date = dta.toISOString().split("T")[0];

            //busca o id do agente do gptmaker
            const telephoneref = doc(db, "db_telephone", tel);
            const telephonesnap = await getDoc(telephoneref);
            
            if (!telephonesnap.exists()) {
                throw new Error("Telefone não encontrado");
            }
        
            const idg = telephonesnap.data().id_gptmaker;

            wait(500);

            const resGptMaker = await fetch(ENDPOINTS.gptmaker.dashs1,
                { method: "POST", headers: {"Content-Type": "application/json"},
                  body: JSON.stringify({
                    agent_id: idg,
                    start_date: start_date,
                    })
                });
           
            const resultGptMaker = await resGptMaker.json();
            if(resultGptMaker.error) {
                return;
            }

            const resumo = resultGptMaker.resumo;

            let chart = [];

            if(ast == 3) {

                const diasResumo = resumo.por_dia || {};
                const dias_map = Object.keys(diasResumo).reduce((acc, key) => {acc[key] = diasResumo[key]; return acc;}, {});

                for(let i = 0; i < 7; i++) {

                    const dia = new Date(dta);
                    dia.setDate(dia.getDate() + i);

                    const yyyy = dia.getFullYear();
                    const mm = String(dia.getMonth() + 1).padStart(2, '0');
                    const dd = String(dia.getDate()).padStart(2, '0');

                    const key = `${yyyy}-${mm}-${dd}`;
                    const dados = dias_map[key] || { resolvidos: 0, nao_resolvidos: 0 };

                    chart.push({dia: key, resolvidos: dados.resolvidos, nconcluido: dados.nao_resolvidos, concluido: dados.resolvidos, total: dados.resolvidos + dados.nao_resolvidos, rotulo: `dia ${i + 1}`});
                }
            }

            if(ast == 4 || ast == 5) {

                const mesesResumo = resumo.por_mes || {};
                const meses_map = Object.keys(mesesResumo).reduce((acc, key) => {acc[key] = mesesResumo[key]; return acc;}, {});

                for(let i = 0; i < 7; i++) {

                    const mes = new Date(dta);
                    mes.setMonth(mes.getMonth() + i);

                    const yyyy = mes.getFullYear();
                    const yy = String(yyyy).slice(-2);
                    const mm = String(mes.getMonth() + 1).padStart(2, '0');

                    const key = `${yyyy}-${mm}`;
                    const dados = meses_map[key] || { resolvidos: 0, nao_resolvidos: 0 };

                    let nomeMes = mes.toLocaleDateString("pt-BR", { month: "short" });
                    nomeMes = nomeMes.replace(".", ""); // remove ponto (fev.)
                    nomeMes = nomeMes.charAt(0).toUpperCase() + nomeMes.slice(1);

                    const rotulo = `${nomeMes}.${yy}`;

                    chart.push({mes: key, resolvidos: dados.resolvidos, nconcluido: dados.nao_resolvidos, concluido: dados.resolvidos, total: dados.resolvidos + dados.nao_resolvidos, rotulo: rotulo});
                }
            }

            setChart(chart);
            
        } catch (erro) {
            alert("Erro ao montar gráfico: " + erro.message);
        }
        
    }

    
    async function getNextSchedules() {

        try {

            let aid = basic.agent.id;

            const logsRef = collection(db, "ls_calendar");
            const q = query(logsRef, where("id_agent", "==", aid), orderBy("date", "desc"), limit(20));
            const logsSnap = await getDocs(q);

            if(logsSnap.empty) {
                setAgenda([]);
                return [];
            }

            //bruto DESC (mais novo → mais antigo)
            const brutoDesc = [];
            logsSnap.forEach((logDoc) => { const log = logDoc.data();
            brutoDesc.push({dia: log.dia.split('/').join('.'), hora: log.hora, scheduledAt: log.date?.toDate ? log.date.toDate() : log.date, nome: log.nome, telefone: log.telefone, email: log.email, action: log.action, timestamp: log.date?.toDate ? log.date.toDate().getTime() : 0, atendimento: log.atendimento});    
            });

            //transformar para ASC (mais antigo → mais novo)
            const bruto = [...brutoDesc].reverse();

            const processado = [];
            const usado = new Set();

            for (let i = 0; i < bruto.length; i++) {
                if (usado.has(i)) continue;

                const atual = bruto[i];

                //se for CANCEL → procurar ADD DEPOIS (em ordem cronológica)
                if (atual.action === "CANCEL") {
                    for (let j = i + 1; j < bruto.length; j++) {
                        const prox = bruto[j];
                        if (usado.has(j)) continue;

                        const mesmoEmail = prox.email === atual.email;
                        const intervalo = Math.abs(atual.timestamp - prox.timestamp);

                        if (prox.action === "ADD" && mesmoEmail && intervalo <= 30 * 60 * 1000) {
                            
                            usado.add(i);
                            usado.add(j);
                            processado.push({dia: prox.dia, hora: prox.hora, scheduledAt: prox.scheduledAt, nome: prox.nome, telefone: prox.telefone, action: "REAGENDADO", atendimento: prox.atendimento});
                            break;
                            
                        }
                    }
                }

                if(!usado.has(i)) {
                    processado.push({dia: atual.dia, hora: atual.hora, scheduledAt: atual.scheduledAt, nome: atual.nome, telefone: atual.telefone, action: atual.action === "ADD" ? "AGENDADO" : "CANCELADO", atendimento: atual.atendimento});
                }
            }

            // processado está ASC → pegar últimos 4
            const final = processado.slice(-4);

            // ordenar para exibir: antigo→1 ... novo→4
            setAgenda(final);

        } 
        catch(erro) {
            console.error("getNextSchedules: ", erro);
            setAgenda([]);
            return [];
        }
    }

    const panel = statusAgentsPanel(basic?.agent?.status ?? -1);



    async function active_agent() {
        
        setLoaded6(true);

        try {

            let aid = basic.agent.id;
            let tel = basic.agent.telefone;
            tel = "55" + tel.replace(/\D/g, "");

            // busca qual o limite que realizou o bloqueio
            const hoje = new Date();
            
            let ano = hoje.getFullYear();
            let mes = hoje.getMonth() + 1;

            const creditsdb = collection(db, "db_credit");
            const creditsquery = query(creditsdb, where("id_agent", "==", aid), where("ano", "==", ano), where("mes", "==", mes), where("limite", ">", 900), where("data_ativacao", "==", null), orderBy("data_execucao", "desc"), limit(1));

            const creditsdoc = await getDocs(creditsquery);

            let limite = creditsdoc.docs[0].data().limite;

            const telephoneref = doc(db, "db_telephone", tel);
            const telephonesnap = await getDoc(telephoneref);

            if(!telephonesnap.exists()) {
                console.log("Telefone não encontrado");
                return;
            }

            const telephone = telephonesnap.data();

            let gptmaker = telephone.id_gptmaker;

            const resGptMaker = await fetch(ENDPOINTS.gptmaker.agentActive,
            { 
                method: "POST", headers: {"Content-Type": "application/json"},
                
                body: JSON.stringify({
                    agent_id: aid,
                    id_gptmaker: gptmaker,
                    limite: limite,
                    ano: ano,
                    mes: mes,
                    motivo: "compra de créditos pelo cliente"
                })
            });
        
            const resultGptMaker = await resGptMaker.json();
            
            if(resultGptMaker.error) {
                console.log(resultGptMaker.error)
                return;
            }
        
        }
        catch(erro) {
            console.log(erro);
        }
        finally {
            setLoaded6(false);
        }
        
    }



    async function change_agent(id) {

        try {

            setLoaded8(true);

            const uid = basic.client.idDoc;

            const agentsref = collection(db, "db_agent");

            const agentquery = query(agentsref, where("id_client", "==", uid));

            const agentsnap = await getDocs(agentquery);

            const batch = writeBatch(db);

            agentsnap.forEach((docSnap) => {batch.update(docSnap.ref, {principal: docSnap.id === id});});

            await batch.commit();

            window.location.reload();

        } catch (e) {
            alert("Erro ao trocar o agente.");
            console.error(e);
        }
        
    }



    
    return(

        <div className="context">

            <Header access={1}></Header>

            <div className="content">
                <div className="ft_topico">Painel do cliente</div>
                <div className="ft_descricao">Esse é o Painel do cliente, aqui você pode configurar seu agente, ver a peformance de atendimento dele, acompanhar seus pagamentos de mensalidade e alterar seus dados pessoais quando precisar.</div>
                <div className="space"></div>

                <div className="panel_box">
                    <div className="panel_box_space-mobile"></div>

                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_agent}></img></div>
                        { agBlock ? (
                        <>
                        <div className="panel_box_content_block">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Agente bloqueado</div>
                                <span className="panel_box_contentaviso_block">Seu agente foi bloqueado devido a ultrapassar o limite de consumo de {agBlock} créditos.</span>
                                <span className="panel_box_contentaviso_block">Para desbloqueá-lo, temos as seguintes opções:</span>
                                <span className="panel_box_contentitem_block">- Compra de 1.000 créditos no valor de R$ 50,00</span>
                                <span className="panel_box_contentitem_block">- Aguardar até o prazo de renovação dos créditos (primeiro dia do mês)</span>
                                <span className="panel_box_contentspace"></span>
                                <span className="panel_box_contentdetails_block">A compra dos créditos só sera cobrada na próxima fatura.</span>
                                <span className="panel_box_contentdetails_block">Ainda com dúvidas: Leia nossos&nbsp;<a href="/terms" className="panel_box_contentterms_block" target="_blank" rel="noopener noreferrer">Termos de Uso.</a></span>
                                <span className="panel_box_contentspace"></span>
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt1" className={loaded6 ? "button_disabled_form" : "button_form"} onClick={ active_agent } disabled={loaded6}>{loaded6 ? "AGUARDE ..." : "DESBLOQUEAR"}</button>
                            </div>
                        </div>
                        </>) : (
                        <>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Configure seu agente</div>
                                <span className="panel_box_contentaviso">Aqui é onde você cria, modifica e confere o status do seu agente.</span>
                                
                                <div className="panel_box_infos">
                                { !loaded1 ? (<><span className="panel_box_contentinfo_load">carregando ...</span></>) : (
                                    <>                           
                                    <span className="panel_box_contentitem">Nome do Agente:<span className="panel_box_contentresult">&nbsp;{ basic.agent.nome }</span></span>
                                    <span className="panel_box_contentitem">Data de Criação:<span className="panel_box_contentresult">&nbsp;{ formatTimestamp(basic.agent.data_criacao) }</span></span>
                                    <span className="panel_box_contentitem">Número do Agente:<span className="panel_box_contentresult">&nbsp;{ basic.agent.telefone }</span></span>
                                    <span className="panel_box_contentspace">
                                        <span className="panel_box_contentline"></span>
                                    </span>
                                    <span className="panel_box_contentitem">Status:<span className="panel_box_contentresult">&nbsp;{panel?.[0]?.textStatus}</span></span>
                                    <span className="panel_box_contentitem">Data da Configuração<span className="panel_box_contentresult">&nbsp;{ dtConf === null ? "" : formatTimestamp(dtConf) }</span></span>
                                    <span className="panel_box_contentspace">
                                        <span className="panel_box_contentline"></span>
                                    </span>
                                    <span className="panel_box_contentitem">{basic.agent.status > 5 ? "Data de Desativação:" : "Data de Ativação:"}<span className="panel_box_contentresult">&nbsp;{ dtAtiv === null ? "" : formatTimestamp(dtAtiv) }</span></span>
                                    </>)}
                                </div>

                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt1" className={!loaded1 ? "button_disabled_form" : basic.agent.status === 5 ? "button2_form" : panel?.[0]?.classButton} onClick={() => execute_agent(false)} disabled={!loaded1}>{panel?.[0]?.textButton}</button>
                            </div>
                        </div>                        
                        </>)}
                    </div>

                    <div className="panel_box_space"></div>

                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_schedule}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Agenda</div>
                                <span className="panel_box_contentaviso">Visualize todos os seus compromissos, tudo o que seus pacientes agendaram com você.</span>
                                { panel?.[1]?.viewPanel ? (
                                <>
                                <div className="panel_box_contentchart">
                                    { !loaded2 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : (
                                    <>
                                    <AgendaPanel agenda={agenda} agentStatus={basic.agent.status}/>
                                    </>
                                    )}
                                </div>
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt2" className={!loaded2 ? "button_disabled_form" : panel[1].classButton} onClick={ (e)=> navigate(basic.agent.status === 3 ? "/billing" : "/schedule") } disabled={!loaded2}>VER AGENDA</button>
                                </>
                                ) : (<><span className="panel_box_content_status">{panel?.[1]?.textPanel}</span><span className="panel_box_contentconfigure_space"></span></>)}
                            </div>
                        </div>
                    </div>

                    <div className="panel_box_space"></div>
                </div>

                <div className="space-mobile"></div>

                <div className="panel_box">
                    <div className="panel_box_space-mobile2"></div>
                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_graphics}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Performance do agente</div>
                                <span className="panel_box_contentaviso">Verifique o desempenho do seu agente com base na produtividade de atendimentos.</span>
                                { panel?.[2]?.viewPanel ? (
                                <>
                                <div className="panel_box_contentchart">
                                    { !loaded2 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : (
                                    <>
                                      <ResponsiveContainer>
                                        <BarChart margin={{top: 20}} data={chart}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="rotulo" tick={{fontSize: 10}} />
                                        <YAxis hide={true} />
                                        <Tooltip />
                                        <Legend wrapperStyle={{fontSize: 11}} formatter={(value, entry) => {if (value === 'concluido') return 'Resolvido'; if (value === 'nconcluido') return 'Não Resolvido'; return value;}} />
                                        <Bar dataKey="concluido" stackId="a" fill="green" />
                                        <Bar dataKey="nconcluido" stackId="a" fill="red">
                                        <LabelList
                                            dataKey="nconcluido"
                                            position="top"
                                            content={(props) => {
                                            const { x, y, width, value, index } = props;
                                            const total = chart[index].concluido + chart[index].nconcluido;
                                            return (<text x={x + width / 2} y={y - 5} textAnchor="middle" fill="black" fontSize={12}>{total}</text>);
                                            }}
                                        />
                                        </Bar>
                                        </BarChart>
                                    </ResponsiveContainer>
                                    </>)}
                                </div>
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt2" className={!loaded2 ? "button_disabled_form" : panel[2].classButton} onClick={ (e)=> navigate(basic.agent.status === 3 ? "/billing" : "/performance") } disabled={!loaded2}>VER MAIS</button>
                                </>
                                ) : (<><span className="panel_box_content_status">{panel?.[2]?.textPanel}</span><span className="panel_box_contentconfigure_space"></span></>)}

                            </div>
                        </div>
                    </div>

                    <div className="panel_box_space"></div>

                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_payment}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Planos e pagamentos</div>
                                <span className="panel_box_contentaviso">Acompanhe o período de testes do seu agente, bem como o pagamento das mensalidades.</span>
                                { panel?.[3]?.viewPanel ? (
                                <>
                                <div className="panel_box_contentpayment">

                                { basic.agent.status === 3 && (
                                <>
                                    { !loaded1 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : 
                                    <>    
                                    <span className="panel_box_contentpayment_title">Período de testes gratuíto</span>
                                    <div className="panel_box_contentpayment_frame">
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#00B050", height: difhrs >= 24 ? "100%" : (difhrs * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 24 ? "4px" : "0px", borderTopRightRadius: difhrs >= 24 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 1</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#66C266", height: difhrs >= 48 ? "100%" : ((difhrs - 24) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 48 ? "4px" : "0px", borderTopRightRadius: difhrs >= 48 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 2</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#B7D77A", height: difhrs >= 72 ? "100%" : ((difhrs - 48) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 72 ? "4px" : "0px", borderTopRightRadius: difhrs >= 72 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 3</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#FFD966", height: difhrs >= 96 ? "100%" : ((difhrs - 72) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 96 ? "4px" : "0px", borderTopRightRadius: difhrs >= 96 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 4</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#F4B183", height: difhrs >= 120 ? "100%" : ((difhrs - 96) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 120 ? "4px" : "0px", borderTopRightRadius: difhrs >= 120 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 5</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#E06666", height: difhrs >= 144 ? "100%" : ((difhrs - 120) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 144 ? "4px" : "0px", borderTopRightRadius: difhrs >= 144 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 6</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#C00000", height: difhrs >= 168 ? "100%" : ((difhrs - 144) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 168 ? "4px" : "0px", borderTopRightRadius: difhrs >= 168 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 7</div>
                                        </div>
                                    </div>
                                    </>
                                    }
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt3a" className={!loaded1 ? "button_disabled_form" : panel[3].classButton} disabled={!loaded1} onClick={ (e)=> navigate("/billing") }>{panel[3].textButton}</button>
                                </>
                                )}

                                { (basic.agent.status === 4 || basic.agent.status === 5) && (
                                <>
                                    { !loaded4 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : 
                                    <>
                                    <span className="panel_box_contentitem">Assinante desde:<span className="panel_box_contentresult">&nbsp;{ dadosBilling.assinatura }</span></span>
                                    <span className="panel_box_contentitem">Vencimento (dia) :<span className="panel_box_contentresult">&nbsp;{ dadosBilling.vencimento }</span></span>
                                    <span className="panel_box_contentitem">Créditos usados no mês:<span className="panel_box_contentresult">&nbsp;{ credits }</span></span>
                                    <span className="panel_box_contentspace">
                                        <span className="panel_box_contentline"></span>
                                    </span>
                                    <span className="panel_box_contentitem">Plano:<span className="panel_box_contentresult">&nbsp;{ dadosBilling.plano + " (" + dadosBilling.id_plano + ")" }</span></span>
                                    <span className="panel_box_contentitem">Valor do Plano:<span className="panel_box_contentresult">&nbsp;{ "R$ " + dadosBilling.valor }</span></span>
                                    <span className="panel_box_contentspace">
                                        <span className="panel_box_contentline"></span>
                                    </span>
                                    <span className="panel_box_contentitem">Status Assinatura:<span className="panel_box_contentresult" style={{color: dadosBilling.situacao ? "red" : "green"}}>&nbsp;{ dadosBilling.situacao ? "Pagamento em atraso" : "Pagamentos em dia" }</span></span>
                                    <span className="panel_box_contentspace"></span>
                                    
                                    </>
                                    }
                                <button type="button" name="bt3a" className={!loaded4 ? "button_disabled_form" : panel[3].classButton} disabled={!loaded4} onClick={ (e)=> navigate("/billing") }>{panel[3].textButton}</button>
                                </>
                                )}

                                </div>
                                </>
                                ) : (<><span className="panel_box_content_status">{panel?.[3]?.textPanel}</span><span className="panel_box_contentconfigure_space"></span></>)}

                            </div>
                        </div>
                    </div>


                    <div className="panel_box_space"></div>
                </div>

                <div className="space-mobile"></div>

                <div className="panel_box">
                    <div className="panel_box_space-mobile2"></div>
                    
                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_config}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Configurações</div>
                                <span className="panel_box_contentaviso">Altere seus dados cadastrais, sua senha e demais configurações.</span>
                                { panel?.[4]?.viewPanel ? (
                                <>
                                    { !loaded3 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : (
                                    <>
                                    <div className="panel_box_contentconfigure">
                                        <span className="panel_box_contentitem">Empresa:</span>
                                        <span className="panel_box_contentresult">{ basic.client.empresa }</span>
                                        <span className="panel_box_contentitem">Responsável:</span>
                                        <span className="panel_box_contentresult">{ basic.client.responsavel }</span>
                                        <span className="panel_box_contentspace">
                                            <span className="panel_box_contentline"></span>
                                        </span>
                                        <span className="panel_box_contentitem">Email:<span className="panel_box_contentresult">&nbsp;{ basic.client.email }</span></span>
                                        <span className="panel_box_contentitem">Data de Cadastro:<span className="panel_box_contentresult">&nbsp;{ formatTimestamp(basic.client.data_criacao) }</span></span>
                                    </div>                            
                                    </>
                                    )}
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt4" className={!loaded3 ? "button_disabled_form" : panel[4].classButton} onClick={ (e)=> navigate("/account") } disabled={!loaded3}>{panel[4].textButton}</button>
                                </>
                                ) : (<><span className="panel_box_content_status">{panel?.[4]?.textPanel}</span><span className="panel_box_contentconfigure_space"></span></>)}
                            </div>
                        </div>
                    </div>

                    <div className="panel_box_space"></div>

                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_management}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder_agentmanagement">
                                <div className="panel_box_contenttitle">Gestão de Agentes</div>
                                <span className="panel_box_contentaviso">Selecione qual o agente que você quer visualizar e acompanhe todas as informações dele.</span>
                                    <div className="panel_box_agentmanagement">
                                    { !loaded7 ? (<><span className="panel_box_contentchart_load" style={{height: "15.5rem"}}>carregando ...</span></>) : (
                                    <>
                                    <div className="panel_box_agentmanagement_content" style={{height: agManagent.botao ? "11.8rem": "15.5rem"}}>

                                    { loaded8 ? (<><span className="panel_box_agentmanagement_wait">carregando ...</span></>) : 
                                    (<>

                                        { agManagent.agentes.length === 0 ? (<><span className="panel_box_agentmanagement_wait">nenhum agente criado</span></>) :
                                        (<>

                                            {agManagent.agentes.map((agente, index) => (
                                            <div key={agente.id}>
                                                <div className={`panel_box_agentmanagement_item ${agente.principal ? "disabled" : ""}`} onClick={!agente.principal ? () => change_agent(agente.id) : undefined}>
                                                        <div className="panel_box_agentmanagement_boxA" style={{backgroundColor: agente.principal ? "var(--PRI_2)" : "", borderTopLeftRadius: index === 0 ? "5px" : "0px"}}></div>
                                                        <div className="panel_box_agentmanagement_boxB">
                                                            <div className="panel_box_agentmanagement_line">
                                                                <span className="panel_box_agentmanagement_label">Agente:&nbsp;</span>
                                                                <span className="panel_box_agentmanagement_data">{agente.nome}</span>
                                                            </div>
                                                            <div className="panel_box_agentmanagement_line">
                                                                <span className="panel_box_agentmanagement_label">Telefone:&nbsp;</span>
                                                                <span className="panel_box_agentmanagement_data">{agente.telefone}</span>
                                                            </div>
                                                            <div className="panel_box_agentmanagement_line">
                                                                <span className="panel_box_agentmanagement_label">Status:&nbsp;</span>
                                                                <span className="panel_box_agentmanagement_data">{agente.descricao_status}</span>
                                                            </div>
                                                        </div>
                                                </div>
                                            </div>
                                            ))}
                                        
                                        </>)}

                                    </>)}

                                    </div>
                                    <div className="panel_box_agentmanagement_space"style={{height: agManagent.botao ? "0.6rem": "0rem"}}></div>
                                    <div className="panel_box_agentmanagement_button" style={{height: agManagent.botao ? "3.1rem": "0rem"}}>
                                        { agManagent.botao && (<><button type="button" name="bt6" className="button2_form" onClick={() => execute_agent(true)}>CRIAR NOVO AGENTE</button></>) }
                                    </div>
                                    </>)}
                                    </div>                 
                                <span className="panel_box_contentspace"></span>
                            </div>
                        </div>
                    </div>

                    <div className="panel_box_space-mobile2"></div>
                </div>

                <div className="space"></div>
                <div className="space"></div>
                <div className="space"></div>

            </div>

            <Footer access={1}></Footer>

        </div>

    )
}